import { render, staticRenderFns } from "./xianshizhi.vue?vue&type=template&id=5a3ada34&scoped=true"
import script from "./xianshizhi.vue?vue&type=script&lang=js"
export * from "./xianshizhi.vue?vue&type=script&lang=js"
import style0 from "./xianshizhi.vue?vue&type=style&index=0&id=5a3ada34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3ada34",
  null
  
)

export default component.exports